export default __webpack_public_path__ + "static/media/fallback-error.85829256.svg";